export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7938.821957b0.jpg";